import { optionSelectorForm } from "./option-selector-form";
import { OptionSelectorListener } from "./option-selector-listener";

export class OptionSelector {
    public static init(root: ParentNode = document): void {
        const wraps = optionSelectorForm.getWraps(root);
        wraps.forEach((wrap) => {
            if (!(wrap instanceof HTMLElement)) return;
            if (wrap.dataset.optionSelectorInit === "1") return;
            wrap.dataset.optionSelectorInit = "1";

            OptionSelectorListener.bindWrapChange(wrap, () => {
                optionSelectorForm.getLabels(wrap).forEach((label) => {
                    if (!(label instanceof HTMLElement)) return;
                    label.classList.toggle("selected", !!optionSelectorForm.getCheckedRadio(label));
                });
            });

            wrap.dispatchEvent(new Event("change"));
        });
    }
}
